import * as S from "./styled"

import minus from "../../assets/icons/minus.png"
import plus from "../../assets/icons/plus.png"
import { formatMoney } from "../../utils/tb/formatMoney"
import { TTicketDisposal } from "../../utils/@types/data/ticket"

type Props = {
  k?: number
  ticket: TTicketDisposal
  changeQnt?: (
    ticketId: number | string,
    action: "decrease" | "increase"
  ) => void
  hasControl?: boolean
}

const Ticket = ({ k, ticket, changeQnt, hasControl = true }: Props) => {
  return (
    <S.Component $k={k}>
      <S.TicketInfo>
        <S.TicketName>{ticket.name}</S.TicketName>
        {ticket.description && (
          <S.TicketDescription>{ticket.description}</S.TicketDescription>
        )}
        {ticket.price_sell && (
          <S.TicketPrice>{formatMoney(ticket.price_sell)}</S.TicketPrice>
        )}
      </S.TicketInfo>
      <S.Quantity $saledOut={ticket.quantity === 0}>
        {ticket.quantity === 0 ? (
          <span style={{ width: "100%", maxWidth: 120, textAlign: "center" }}>
            <strong>Esgotado</strong>
          </span>
        ) : (
          <S.QntControl>
            {ticket.quantity - ticket.qnt <= 10 &&
              ticket.quantity - ticket.qnt >= 0 && (
                <span
                  style={{
                    width: "100%",
                    maxWidth: 120,
                    textAlign: "center",
                    fontSize: 12,
                    color: "#6b7280",
                    whiteSpace: "nowrap",
                  }}
                >
                  Restam {ticket.quantity - ticket.qnt} ingresso
                  {ticket.quantity - ticket.qnt > 1 && "s"}
                </span>
              )}
            <S.ControlsButtonsArea>
              {hasControl && changeQnt && (
                <S.Control
                  type="button"
                  $disabled={ticket.qnt === 0}
                  disabled={ticket.qnt === 0}
                  onClick={() => changeQnt(ticket.id, "decrease")}
                  aria-label={`Diminuir quantidade de ${ticket.name}`}
                >
                  <img src={minus} alt="" aria-hidden="true" />
                </S.Control>
              )}
              <span aria-live="polite" aria-atomic="true">
                {ticket.qnt}
              </span>
              {hasControl && changeQnt && (
                <S.Control
                  type="button"
                  $disabled={
                    ticket.quantity - ticket.qnt < 1 || ticket.qnt >= 20
                  }
                  disabled={
                    ticket.quantity - ticket.qnt < 1 || ticket.qnt >= 20
                  }
                  onClick={() => changeQnt(ticket.id, "increase")}
                  aria-label={`Aumentar quantidade de ${ticket.name}`}
                >
                  <img src={plus} alt="" aria-hidden="true" />
                </S.Control>
              )}
            </S.ControlsButtonsArea>
          </S.QntControl>
        )}
      </S.Quantity>
    </S.Component>
  )
}

export default Ticket
